<template>
  <div v-if="$store.state.screenWidth>900" class="crumbsNav flexSpace">
    <div class="pcFont16 a333 fontW500">{{title}}</div>
    <div class="flexStart pcFont12 a999">
      <div>您的位置： <router-link :to="'/'">首页 </router-link>
      </div>
      <div class="crumbsNav-list-item flexCenter"
           v-for="item in routerArr"
           :key="item.path">
        <router-link :to="item.path">{{item.name}}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "routerArr"],
};
</script>

<style lang="less" scoped>
.crumbsNav {
  height: 90px;
  border-bottom: 1px solid #e5e5e5;
  .crumbsNav-list-item::before {
    content: ">";
    padding: 0 8px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/crumbsNav/crumbsNav.vue